import { ShieldCheck, Clock, MapPin, Headset } from "lucide-react";
const indicators = [{
  icon: ShieldCheck,
  title: "Clinical Excellence"
}, {
  icon: Clock,
  title: "15+ Years Experience"
}, {
  icon: MapPin,
  title: "Limassol & Nicosia"
}, {
  icon: Headset,
  title: "Ongoing Patient Support"
}];
export default function IndicadoresDeConfianza() {
  return <section data-section-id="154917" id="trust-signals" className="bg-muted/30 text-foreground py-[120px] border-y border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {indicators.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center space-y-6 transition-all duration-300 hover:scale-[1.02] group">
                <div className="flex h-20 w-20 items-center justify-center rounded-full bg-accent/10 group-hover:bg-accent/20 transition-colors">
                  <Icon className="h-10 w-10 text-accent" strokeWidth={2} aria-hidden="true" />
                </div>
                <h3 className="font-sans text-lg font-medium text-primary tracking-tight">
                  {item.title}
                </h3>
              </div>;
        })}
        </div>
      </div>
    </section>;
}